grecaptcha.ready(function() {
    grecaptcha.execute($('#recaptcha').html(), {action: 'homepage'})
.then(function(token) {
        $('input[name="g-recaptcha-response"]').val(token);
    });
});
